const NANP_E164 = /^\+1(\d{3})(\d{3})(\d{4})$/;

/** Hyphenates a North American E.164 number so a rep can read it aloud; other numbers pass through. */
export function formatCallerId(e164: string): string {
	const match = NANP_E164.exec(e164.trim());
	return match ? `+1-${match[1]}-${match[2]}-${match[3]}` : e164;
}
